const strict = true;

const state = {
  loadingDialog: false
};

const getters = {
  loadingDialog: state => state.loadingDialog
};

const mutations = {
  reset(state) {
    state.loadingDialog = false;
  },
  openLoadingDialog(state) {
    state.loadingDialog = true;
  },
  closeLoadingDialog(state) {
    state.loadingDialog = false;
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
